import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
    
    // Log error to console in development
    if (process.env.NODE_ENV === 'development') {
      console.error('ErrorBoundary caught an error:', error, errorInfo);
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="error-boundary" role="alert">
          <div className="container">
            <div className="error-content">
              <h1>Oops! Something went wrong</h1>
              <p>We're sorry, but something unexpected happened. Please try refreshing the page.</p>
              <button 
                onClick={() => window.location.reload()} 
                className="btn btn-primary"
                type="button"
              >
                Refresh Page
              </button>
              {process.env.NODE_ENV === 'development' && (
                <details className="error-details mt-4">
                  <summary>Error Details (Development Only)</summary>
                  <pre>{this.state.error && this.state.error.toString()}</pre>
                  {this.state.errorInfo && (
                    <pre>{this.state.errorInfo.componentStack}</pre>
                  )}
                </details>
              )}
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;